import Count        from "../../fundamentals/count/Count";
import Pagination   from "../../fundamentals/pagination/Pagination";
import MailTemplate from "./MailTemplate";

class MailTemplates {
  constructor(
    private readonly _list: MailTemplate[] = [],
    private readonly _pagination: Pagination = new Pagination(),
    private readonly _count: Count = new Count(),
  ) {
  }

  public isEmpty() {
    return this._list.length <= 0;
  }

  public toList(): MailTemplate[] {
    return this._list;
  }

  get pagination() {
    return this._pagination;
  }

  get count() {
    return this._count;
  }
}

export default MailTemplates;
